
import { useState } from 'react';

export default function GallerySection() {
  const [currentImage, setCurrentImage] = useState(0);

  const images = [
    { src: '/assets/img/custom-images/quees/paje-burrita.jpeg', alt: 'La burrita y el paje' },
    { src: '/assets/img/custom-images/quees/pajes-antorchas.jpeg', alt: 'Pajes con antorcha' },
    { src: '/assets/img/custom-images/quees/pajes-jaima.jpeg', alt: 'Pajes en la jaima' },
    { src: '/assets/img/custom-images/quees/reyes-oscuridad.jpeg', alt: 'Los Reyes Magos en la oscuridad' }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section
      id="galeria"
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://readdy.ai/api/search-image?query=Magical%20Christmas%20night%20sky%20with%20stars%20and%20aurora%20borealis%2C%20deep%20blue%20and%20purple%20colors%2C%20mystical%20winter%20atmosphere%2C%20snow-covered%20landscape%2C%20peaceful%20and%20serene%20background%20for%20photo%20gallery%2C%20cinematic%20lighting%2C%20festive%20Christmas%20spirit%2C%20beautiful%20winter%20wonderland%20scene&width=1920&height=1080&seq=gallery1&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-white mb-6">Una imagen vale más que mil palabras</h1>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white rounded-lg shadow-2xl overflow-hidden">
            <img
              src={images[currentImage].src}
              alt={images[currentImage].alt}
              className="w-full h-96 object-cover"
            />

            <button
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-left-line text-xl"></i>
              </div>
            </button>

            <button
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all duration-300"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xl"></i>
              </div>
            </button>

            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
              {images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImage(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-white' : 'bg-white/50'
                    }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
